import React, { useState } from 'react';
import axios from 'axios';
import './HighlightsForm.css';

const HighlightsForm = () => {
  // 1. Data for Checkboxes (Matches Image 2)
  const agriOptions = [
    "Wheat", "Maize", "Barley", "Soybean",
    "Rapeseed", "Pulses", "Rice", "Bajra",
    "Coriander", "Cumin", "Turmeric", "Chili",
    "Sugar", "Weather", "Surveys", "Vegetables",
    "All"
  ];

  // 2. Form State
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '',
    company: '', jobTitle: '', country: '',
    message: '',
    interests: [] // Array to store selected checkboxes
  });

  // 3. Handle Text Inputs
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 4. Handle Checkboxes
  const handleCheckbox = (e) => {
    const { value, checked } = e.target;
    let updatedInterests = [...formData.interests];

    if (checked) {
        if(value === "All") {
             updatedInterests = agriOptions; // Select all
        } else {
             updatedInterests.push(value);
        }
    } else {
        if(value === "All") {
             updatedInterests = []; // Deselect all
        } else {
             updatedInterests = updatedInterests.filter(item => item !== value);
        }
    }
    setFormData({ ...formData, interests: updatedInterests });
  };

  // 5. Submit to Backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        // We will create this endpoint next
        const res = await axios.post('http://127.0.0.1:5000/api/highlights-signup', formData);
        if(res.status === 201) {
            alert("Thank you! You have subscribed to our Market Highlights.");
            setFormData({
                firstName: '', lastName: '', email: '', company: '', jobTitle: '', country: '', message: '', interests: []
            });
        }
    } catch (err) {
        alert("Submission failed. Please check your connection.");
        console.error(err);
    }
  };

  return (
    <section className="highlights-form-section">
      <div className="container">
        <form className="form-grid" onSubmit={handleSubmit}>
            
            {/* Checkbox Section */}
            <div className="checkbox-container">
                <label className="checkbox-label">Select categories you are interested in:</label>
                <div className="checkbox-grid">
                    {agriOptions.map((opt) => (
                        <div key={opt} className="checkbox-item">
                            <input 
                                type="checkbox" 
                                value={opt} 
                                onChange={handleCheckbox}
                                checked={formData.interests.includes(opt)}
                            />
                            <span>{opt}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Inputs Section (Matches Image 2 Content + Image 1 Style) */}
            <div className="inputs-grid">
                <input name="firstName" placeholder="First Name" className="hl-input" onChange={handleChange} required />
                <input name="lastName" placeholder="Last Name" className="hl-input" onChange={handleChange} required />
                
                <input name="company" placeholder="Company Name" className="hl-input" onChange={handleChange} required />
                <input name="jobTitle" placeholder="Job Title" className="hl-input" onChange={handleChange} />
                
                <input name="email" type="email" placeholder="Email Address" className="hl-input" onChange={handleChange} required />
                

                <textarea name="message" placeholder="Your Message..." className="hl-textarea full-width" onChange={handleChange}></textarea>
            </div>

            <button type="submit" className="btn-submit-hl">Submit</button>

        </form>
      </div>
    </section>
  );
};

export default HighlightsForm;